var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_423_2122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.00043 19.0009L4.46709 15.6231C3.34502 14.0303 2.8428 12.0827 3.05469 10.1458C3.26658 8.20902 4.17801 6.4161 5.61795 5.10355C7.05788 3.791 8.92732 3.04906 10.8754 3.01696C12.8235 2.98485 14.7164 3.6648 16.1988 4.9292C17.6812 6.19359 18.6512 7.95551 18.9268 9.88431C19.2024 11.8131 18.7646 13.7762 17.6956 15.4051C16.6266 17.034 14.9999 18.2169 13.1208 18.7316C11.2416 19.2464 9.2392 19.0577 7.48932 18.2009L3.00043 19.0009",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33374 9.22298C8.33374 9.34086 8.38057 9.4539 8.46391 9.53725C8.54726 9.6206 8.66031 9.66743 8.77818 9.66743C8.89606 9.66743 9.00911 9.6206 9.09245 9.53725C9.1758 9.4539 9.22263 9.34086 9.22263 9.22298V8.33409C9.22263 8.21622 9.1758 8.10317 9.09245 8.01982C9.00911 7.93647 8.89606 7.88965 8.77818 7.88965C8.66031 7.88965 8.54726 7.93647 8.46391 8.01982C8.38057 8.10317 8.33374 8.21622 8.33374 8.33409V9.22298ZM8.33374 9.22298C8.33374 10.4017 8.80199 11.5322 9.63549 12.3657C10.469 13.1992 11.5994 13.6674 12.7782 13.6674H13.6671C13.7849 13.6674 13.898 13.6206 13.9813 13.5373C14.0647 13.4539 14.1115 13.3409 14.1115 13.223C14.1115 13.1051 14.0647 12.9921 13.9813 12.9087C13.898 12.8254 13.7849 12.7785 13.6671 12.7785H12.7782C12.6603 12.7785 12.5473 12.8254 12.4639 12.9087C12.3806 12.9921 12.3337 13.1051 12.3337 13.223C12.3337 13.3409 12.3806 13.4539 12.4639 13.5373C12.5473 13.6206 12.6603 13.6674 12.7782 13.6674",
    stroke: "#757575",
    strokeWidth: 1.39329,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_423_2122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3333,
    height: 21.3333,
    fill: "white",
    transform: "translate(0.33374 0.333984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIconGray);
export default __webpack_public_path__ + "static/media/whatsappIconGray.180dd67dd5e0070c3a9e76bbc6ef7e45.svg";
export { ForwardRef as ReactComponent };